<template>
  <div>
    <div v-if="!data.length" class="lego-manual-box__row empty">
      Component has no slot.
    </div>
    <template v-for="(item, idx) in data">
      <div v-if="!item.hide" class="lego-manual-box__row">
        <div class="lego-manual-box__left-area">
          <div class="lego-manual-box__item name">
            <div class="lego-manual-box__item__label">
              Name
            </div>
            <div class="lego-manual-box__item__value">
              {{ item.name }} <span v-if="item.abbr">(= {{ item.abbr }})</span>
            </div>
          </div>
          <!-- <div class="lego-manual-box__item tag">
                <div class="lego-manual-box__item__label">Tag</div>
                <div class="lego-manual-box__item__value">
                    <div v-if="item.required" class="lego-manual-box__item__value__badge required">required</div>
                    <template v-for="(tag, idx) in item.tags">
                        <div class="lego-manual-box__item__value__badge">{{tag}}</div>
                    </template>
                </div>
            </div> -->
        </div>
        <div class="lego-manual-box__right-area">
          <div class="lego-manual-box__item description">
            <div class="lego-manual-box__item__label">Description</div>
            <div class="lego-manual-box__item__value" v-if="lang==='ko'" v-html="item.describe" ></div>
            <div class="lego-manual-box__item__value" v-if="lang==='en'" v-html="item.describeEn" ></div>
          </div>
          <div class="lego-manual-box__item slot-scope">
            <div class="lego-manual-box__item__label">Slot-scope</div>
            <div class="lego-manual-box__item__value" v-if="item.bindings">
              <template v-for="(desc, key) in item.bindings">
                {{ desc }}
              </template>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type:Array,
      default: function () {
        return [];
      }
    },
    lang: {type:String,default:'ko'}
  },
};
</script>